const buildBasicInfo = (ini, curr, isNew) => {
    let bodyArr = [];
    if (curr.addCategory && !isNew) {
        bodyArr = [ ...bodyArr, { type: 'adding a category', initId: ini.journalCategoryId, initCopy: ini.category }];
    }
    if (curr.editCategory) {
        const prev = curr.categories.find(x => x.key === curr.journalCategoryId);
        if (prev) bodyArr = [ ...bodyArr, { type: 'editing a category', initId: prev.key, initCopy: prev.text }];
    }
    if (curr.switchCategory && !isNew)
        bodyArr = [ ...bodyArr, { type: 'changing a category', initId: ini.journalCategoryId, initCopy: ini.category }];

    if (curr.prompt !== ini?.prompt && !isNew) 
        bodyArr = [ ...bodyArr, { type: 'editing a prompt', initId: ini.journalPromptId, initCopy: ini.prompt }];

    if (!!curr.checklistOnly !== !!ini?.checklistOnly && !isNew)
        bodyArr = [ ...bodyArr, { type: curr.checklistOnly ? 'hiding a prompt from journal browsing' : 'showing a prompt in journal browsing', initId: ini.journalPromptId, initCopy: ini.prompt }];
    
    if (isNew) bodyArr = [ ...bodyArr, { type: 'adding a new journal', initId: ini.journalPromptId, initCopy: ini.prompt }];

    return bodyArr;
}

const buildI18n = (ini, curr, isNew) => {
    let bodyArr = [];
    if (curr.international !== ini.international && !isNew) 
        bodyArr = [ ...bodyArr, { type: 'changing the international setting', prev: ini.international ? 'On' : 'Off', current: curr.international ? 'On' : 'Off' }];
    
    if (curr.isGlobal !== ini.isGlobal && !isNew) {
        bodyArr = [ ...bodyArr, { type: 'changing the localization', prev: ini.isGlobal ? 'Global' : 'Not Global', current: curr.isGlobal ? 'Global' : 'Not Global' }];
        curr.isGlobal ? curr.includeCountries = [] : curr.excludeCountries = [];
    }
    if (!arraysAreEqual(curr.includeCountries, ini.includeCountries) && !curr.isGlobal && !isNew) {
            bodyArr = [ ...bodyArr, { type: 'changing the countries visible', 
                                        prev: formatCountryList(ini?.includeCountries, curr?.countries), 
                                        current: formatCountryList(curr?.includeCountries, curr?.countries) }];
    }
    if (!arraysAreEqual(curr.excludeCountries, ini.excludeCountries) && curr.isGlobal && !isNew) { 
            bodyArr = [ ...bodyArr, { type: 'changing the countries hidden',
                                        prev: formatCountryList(ini?.excludeCountries, curr?.countries), 
                                        current: formatCountryList(curr?.excludeCountries, curr?.countries) }];
    }
    if (isNew) 
        bodyArr = [ ...bodyArr, { type: 'adding a new journal', 
                                    international: curr.international, 
                                    global: curr.isGlobal, 
                                    countries: curr.isGlobal ? formatCountryList(curr?.excludeCountries, curr?.countries) : formatCountryList(curr?.includeCountries, curr?.countries) }];
    
    return bodyArr;
}

const buildCobrands = (ini, curr, isNew) => {
    let bodyArr = [];
    if (curr.allCobrands !== ini.allCobrands && !isNew) {
        bodyArr = [ ...bodyArr, { type: 'changing the cobrands', prev: ini.allCobrands ? 'All Cobrands' : 'No Cobrands', current: curr.allCobrands ? 'All Cobrands' : 'No Cobrands' }];
        curr.allCobrands ? curr.includeCobrands = [] : curr.excludeCobrands = [];
    }
    if (!arraysAreEqual(curr.includeCobrands, ini.includeCobrands) && !curr.allCobrands && !isNew) {
            bodyArr = [ ...bodyArr, { type: 'changing the cobrands shown', 
                                        prev: formatCountryList(ini?.includeCobrands, curr?.cobrands), 
                                        current: formatCountryList(curr?.includeCobrands, curr?.cobrands) }];
    }
    if (!arraysAreEqual(curr.excludeCobrands, ini.excludeCobrands) && curr.allCobrands && !isNew) { 
            bodyArr = [ ...bodyArr, { type: 'changing the cobrands hidden',
                                        prev: formatCountryList(ini?.excludeCobrands, curr?.cobrands), 
                                        current: formatCountryList(curr?.excludeCobrands, curr?.cobrands) }];
    }
    if (isNew) 
        bodyArr = [ ...bodyArr, { type: 'adding a new journal', 
                                    allCobrands: curr.allCobrands, 
                                    cobrands: curr.allCobrands ? formatCountryList(curr?.excludeCobrands, curr?.cobrands) : formatCountryList(curr?.includeCobrands, curr?.cobrands) }];
    
    return bodyArr;
}

function arraysAreEqual(arr1, arr2) {
    if (arr1?.length !== arr2?.length) {
      return false;
    }
  
    return arr1.every((value, index) => value === arr2[index]);
  }

  function formatStrList(arr) {
    if (!arr) return;
    const strArr = arr.map((s, i) => i === arr.length - 1 ? `'${s}'` : `'${s}', `);
    return strArr;
  }

  function switchPropertyArr(valueArr, valueLabelArr) {
    const labelArr = valueArr.map((val) => {
        const valueLabel = valueLabelArr.find(obj => obj.value === val);
        return valueLabel.label;
    })

    return labelArr;
  }

  function formatCountryList(ids, countries) {
    return formatStrList(switchPropertyArr(ids, countries));
  }

export {
    buildBasicInfo,
    buildI18n,
    arraysAreEqual,
    buildCobrands
}